export default __webpack_public_path__ + "static/media/download_methodiek_extreme meningen.76a3e3a8.pdf";